import PremiumPlansTemplate from "components/templates/PremiumPlansTemplate"

export default function PremiumPlansPage() {
  return (
    <PremiumPlansTemplate/>
  )
}
